import { useEffect, useState } from 'react'
import { messagesApi } from '@/api/endpoints'

/**
 * Load a message's photo or recording through the authenticated API client.
 *
 * A plain `src` on <img>/<audio> sends no Authorization header, so the
 * endpoint answers 401 and the element silently renders nothing — a broken
 * image, or an audio player stuck at 0:00 with no error anywhere. The bytes
 * are fetched with the token attached and handed over as a blob URL instead.
 *
 * Shared, because every screen showing what a customer sent needs it: the
 * order review panel and the conversation thread both.
 */
export function useMediaUrl(messageId, enabled) {
  const [url, setUrl] = useState(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    if (!enabled || !messageId) return undefined

    let revoked = false
    let objectUrl = null

    messagesApi
      .mediaBlobUrl(messageId)
      .then((next) => {
        // The effect may have been cleaned up while the request was in
        // flight; revoking immediately avoids leaking the blob.
        if (revoked) URL.revokeObjectURL(next)
        else {
          objectUrl = next
          setUrl(next)
        }
      })
      .catch(() => setFailed(true))

    return () => {
      revoked = true
      if (objectUrl) URL.revokeObjectURL(objectUrl)
    }
  }, [messageId, enabled])

  return { url, failed }
}

export default useMediaUrl
